import { createFileRoute } from "@tanstack/react-router"
import ErrorPage from "@/components/ErrorPage"

export const Route = createFileRoute("/error")({
  component: ErrorPage
})
